import Vue from 'vue'
import Router from 'vue-router'
import ct from '../utils/constant.js'

import Login from '@/pages/login/Login'
import Register from '@/pages/login/Register'
import ForgetPassword from '@/pages/login/ForgetPassword'

import NetDisk from '@/pages/NetworkDisk'
import DaiDing from '@/pages/DaiDing'
import EMKT from '@/pages/Emkt'
import Shared from '@/pages/share/Shared'
import InputPassCode from '@/pages/share/InputPassCode'

import AllFile from '@/pages/netDisk/AllFile'
import GenechemFile from '@/pages/netDisk/GenechemFile'
import CustomerFile from '@/pages/netDisk/CustomerFile'
import ContractFile from '@/pages/netDisk/ContractFile'
import TagFile from '@/pages/netDisk/TagFile'
import DeletedFile from '@/pages/netDisk/DeletedFile'
import MyShare from '@/pages/netDisk/MyShare'
import MyCommon from '@/pages/netDisk/MyCommon'

Vue.use(Router)

const rt = ct.RouterData

export default new Router({
  routes: [
    {path: rt.login.path, name: rt.login.name, component: Login, keepAlive: true},
    {path: rt.register.path, name: rt.register.name, component: Register, keepAlive: true},
    {path: rt.forgetPass.path, name: rt.forgetPass.name, component: ForgetPassword, keepAlive: true},
    {path: rt.shared.path, name: rt.shared.name, component: Shared, keepAlive: true},
    {path: rt.inputPassCode.path, name: rt.inputPassCode.name, component: InputPassCode, keepAlive: true},
    {
      path: rt.netDisk.path,
      name: rt.netDisk.name,
      components: {default: NetDisk, all: AllFile},
      keepAlive: true,
      children: [
        {path: rt.allFile.path, name: rt.allFile.name, meta: {title: rt.allFile.label}, components: {default: AllFile}, keepAlive: true},
        {path: rt.gcFile.path, name: rt.gcFile.name, meta: {title: rt.gcFile.label}, component: GenechemFile, keepAlive: true},
        {path: rt.cusFile.path, name: rt.cusFile.name, meta: {title: rt.cusFile.label}, component: CustomerFile, keepAlive: true},
        {path: rt.conFile.path, name: rt.conFile.name, meta: {title: rt.conFile.label}, component: ContractFile, keepAlive: true},
        {path: rt.tagFile.path, name: rt.tagFile.name, meta: {title: rt.tagFile.label}, component: TagFile, keepAlive: true},
        {path: rt.myShare.path, name: rt.myShare.name, meta: {title: rt.myShare.label}, component: MyShare, keepAlive: true},
        {path: rt.myCommon.path, name: rt.myCommon.name, meta: {title: rt.myCommon.label}, component: MyCommon, keepAlive: true},
        {path: rt.delFile.path, name: rt.delFile.name, meta: {title: rt.delFile.label}, component: DeletedFile}
      ]
    },
    {path: rt.daiDing.path, name: rt.daiDing.name, component: DaiDing, keepAlive: true},
    {path: rt.emkt.path, name: rt.emkt.name, component: EMKT, keepAlive: true}
  ]
})

// router.beforeEach ((to, from, next) => {
//   console.log('beforeRouteEnter', to)
// })

// export default router



// WEBPACK FOOTER //
// ./src/router/index.js